var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"target-item columns"},[_c('div',{staticClass:"column is-2"},[_c('button',{on:{"click":_vm.deleteTarget}},[_vm._v("×")])]),_c('div',{staticClass:"column is-10"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }